import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { Input } from "@repo/ui/Inputs/input";
import { type FC, useState } from "react";
import { useNavigate } from "react-router";
import { useCreateKnowledgeBaseMutation } from "../../../api/entities/knowledgeBase.js";
import { appPaths } from "../../../app/appPaths.js";
import { useAppDispatch } from "../../../hooks/hook.js";
import {
  NotificationType,
  showNotification,
} from "../../notificationsOverlay/notificationsSlice.js";

interface KnowledgeBaseCreateFormProps {
  close: () => void;
}

export const KnowledgeBaseCreateForm: FC<KnowledgeBaseCreateFormProps> = ({
  close,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [createKnowledgeBase, { isLoading }] = useCreateKnowledgeBaseMutation();

  const handleCreate = async () => {
    if (!name.trim()) {
      return;
    }

    try {
      const newKnowledgeBase = await createKnowledgeBase({ name }).unwrap();
      showNotification(dispatch, {
        id: `knowledge-base-create-success-${Date.now()}`,
        primaryMessage: "Knowledge base created successfully",
        type: NotificationType.SUCCESS,
      });
      close();
      navigate(
        appPaths.settingsKnowledgeBase.build({
          knowledgeBaseId: newKnowledgeBase.id,
        }),
      );
    } catch (error) {
      showNotification(dispatch, {
        id: `knowledge-base-create-error-${Date.now()}`,
        primaryMessage: "Failed to create knowledge base",
        type: NotificationType.FAILURE,
      });
    }
  };

  return (
    <div className="mt-4 flex w-[500px] flex-col space-y-3">
      <Input
        id="knowledge-base-name"
        label="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Enter knowledge base name"
        maxLength={100}
      />

      <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <div className="ml-3">
          <Button
            variant={ButtonVariant.Primary}
            onClick={handleCreate}
            isDisabled={!name.trim() || isLoading}
            isLoading={isLoading}
          >
            Create
          </Button>
        </div>
        <Button
          variant={ButtonVariant.Secondary}
          onClick={close}
          isDisabled={isLoading}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};
